import { useWholeRowPaging } from '../../hooks/useWholeRowPaging';
import type { BigScreenQueue, BigScreenQueueBatch } from '../../lib/big-screen-queue';

function QueueBatch({ batch, featured }: { batch: BigScreenQueueBatch; featured: boolean }) {
  return <div className={`batch ${featured ? 'featured' : ''}`}>
    <div className="st">{featured ? 'Up next' : 'Following'}</div>
    <div className="queue-team-name" title={batch.label}>{batch.label}</div>
    <div className="grid">{batch.shooters.map((shooter, index) => <div className="it" key={`${batch.label}-${shooter.bib}-${index}`}>
      <b>{shooter.bib}</b><span title={shooter.name}>{shooter.name}</span>
    </div>)}</div>
  </div>;
}

/** Right-hand column. Long following lists move automatically while the next team stays visible. */
export function ShootingQueuePanel({ queue, part }: { queue: BigScreenQueue; part?: 'now' | 'next' }) {
  const [first, ...rest] = queue.upcoming;
  return (
    <aside className={`queue ${part ? `queue-${part}` : ''}`} aria-label={part === 'now' ? 'Now shooting' : part === 'next' ? 'Up next' : 'Shooting queue'}>
      {!part ? <div className="qh">Shooting queue</div> : null}
      {part !== 'next' ? <div className="now">
        <div className="st">Now shooting</div>
        {queue.nowTeam ? <div className="queue-team-name" title={queue.nowTeam}>{queue.nowTeam}</div> : null}
        <div className="grid lanes">{queue.now.map((lane) => <div className="it" key={lane.lane}>
          <span className="lane">Lane {lane.lane}</span><b>{lane.bib}</b><span>{lane.name}</span>
        </div>)}</div>
        {queue.now.length === 0 ? <p className="queue-empty">Waiting for the next team.</p> : null}
      </div> : null}
      {part !== 'now' ? <div className="next">
        {first ? <QueueBatch batch={first} featured /> : <div><div className="st">Up next</div><p className="queue-empty">No teams waiting.</p></div>}
        <FollowingBatches batches={rest} />
      </div> : null}
    </aside>
  );
}

function FollowingBatches({ batches }: { batches: BigScreenQueueBatch[] }) {
  const paging = useWholeRowPaging<HTMLDivElement>(batches.map(batch => `${batch.label}:${batch.shooters.length}`).join(','), false, ':scope > .batch');
  return <div className="following-list" ref={paging.viewport}>
    <div className="whole-row-clip" style={{ height: paging.page.height }}>
      <div className="following-pages" ref={paging.content} style={{ transform: `translateY(-${paging.page.offset}px)` }}>
        {batches.map((batch, index) => <QueueBatch key={`${batch.label}-${index}`} batch={batch} featured={false} />)}
      </div>
    </div>
  </div>;
}
